
<template>
  <div>
    <v-header />
    <FirstSwiper />
    <Class />
    <Salarylist />
    <Teacher />
    <SquareVideo v-if="!isMiniProgram"/>
    <Hot />
    <Problem />
    <Campus />
  </div>
</template>

<script>
import VHeader from "./header/VHeader";
import FirstSwiper from "./swiper/First-swiper";
import Class from "./Class";
import Salarylist from "./Salarylist";
import SquareVideo from "./SquareVideo";
import Teacher from "./Teacher";
import Hot from "./Hot";
import Problem from "./Problem";
import Campus from "./campus/Campus";
export default {
  metaInfo:{
  title: '博为峰51Testing软件测试培训网_专注测试,领跑二十多年,软件测试人才的摇篮',
  },
  components: {
    VHeader,
    FirstSwiper,
    Class,
    Salarylist,
    SquareVideo,
    Teacher,
    Hot,
    Problem,
    Campus
  },
  data() {
    return {
      isShow: Boolean,
      isMiniProgram:false
    };
  },
  mounted() {
    // document.documentElement.scrollTop || document.body.scrollTop;
    const userAgent = window.navigator.userAgent.toLowerCase()
    const isaMiniProgram = userAgent.includes('miniprogram')
    if (isaMiniProgram) this.isMiniProgram = true
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css">
.bground {
  background: #000;
  opacity: 0.7;
}
.none-b {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue